export enum ECountry {
  FRANCE = "FRANCE",
  UNITED_KINGDOM = "UNITED_KINGDOM",
  FINLAND = "FINLAND",
  CZECH_REPUBLIC = "CZECH_REPUBLIC",
  HUNGARY = "HUNGARY",
}

export enum ECountryCode {
  FRANCE = "FR",
  UNITED_KINGDOM = "GB",
  FINLAND = "FI",
  CZECH_REPUBLIC = "CZ",
  HUNGARY = "HU",
}

export const CountryToCountryCodeMapping: Record<ECountry, ECountryCode> = {
  [ECountry.FRANCE]: ECountryCode.FRANCE,
  [ECountry.UNITED_KINGDOM]: ECountryCode.UNITED_KINGDOM,
  [ECountry.FINLAND]: ECountryCode.FINLAND,
  [ECountry.CZECH_REPUBLIC]: ECountryCode.CZECH_REPUBLIC,
  [ECountry.HUNGARY]: ECountryCode.HUNGARY,
} as const;

export const CountryCodeToCountryMapping: Record<ECountryCode, ECountry> = {
  [ECountryCode.FRANCE]: ECountry.FRANCE,
  [ECountryCode.UNITED_KINGDOM]: ECountry.UNITED_KINGDOM,
  [ECountryCode.FINLAND]: ECountry.FINLAND,
  [ECountryCode.CZECH_REPUBLIC]: ECountry.CZECH_REPUBLIC,
  [ECountryCode.HUNGARY]: ECountry.HUNGARY,
};
